<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20" v-for="(item,index) in list" :key="index">
                <Col span="7">
                    <FormItem
                        :label="`${countList[index]} <= Lv${item.grade} < `"
                        :prop="'rangeNum'+index"
                        :label-width="140"
                    >
                        <input-number
                            v-model="info['rangeNum'+index]"
                            placeholder
                            :allowDecimal="false"
                        >
                            <span slot="append">万元</span>
                        </input-number>
                    </FormItem>
                </Col>

                <Col span="7">
                    <FormItem label="标题" :prop="'title'+index" :label-width="60">
                        <Input v-model="info['title'+index]" :maxlength="10" placeholder>
                            <span slot="prepend">Lv{{item.grade}}</span>
                        </Input>
                    </FormItem>
                </Col>

                <Col span="5">
                    <FormItem label="分佣比例" :prop="'rate'+index">
                        <input-number
                            v-model="info['rate'+index]"
                            placeholder
                            :min="0"
                            :max="100"
                            :allowNegative="false"
                        >
                            <span slot="append">%</span>
                        </input-number>
                    </FormItem>
                </Col>

                <Col span="5">
                    <FormItem label="冻结天数" :prop="'freezeDays'+index">
                        <input-number
                            v-model="info['freezeDays'+index]"
                            :maxlength="10"
                            placeholder
                            :allowDecimal="false"
                        >
                            <span slot="append">天</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { sRewardRateList, sRewardRateUpdate } from "@/api/sell";
import Dict from "_u/dict";

export default {
    name: "s-reward-rate-form",

    components: {},
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            list: [
                {
                    id: "",
                    grade: "1",
                    rangeNum: 1,
                    title: "",
                    rate: "",
                    freezeDays: 0,
                    remark: "",
                },
                {
                    id: "",
                    grade: "2",
                    rangeNum: 2,
                    title: "",
                    rate: "",
                    freezeDays: 0,
                    remark: "",
                },
                {
                    id: "",
                    grade: "3",
                    rangeNum: 3,
                    title: "",
                    rate: "",
                    freezeDays: 0,
                    remark: "",
                },
            ],
            info: {
                rate0: 0,
                rate1: 0,
                rate2: 0,

                title0: "",
                title1: "",
                title2: "",

                rangeNum0: "",
                rangeNum1: "",
                rangeNum2: "",

                freezeDays0: 0,
                freezeDays1: 0,
                freezeDays2: 0,
            },
            dict: {
                vipLevel: Dict.NULL,
            },
        };
    },

    computed: {
        ruleValidate() {
            const validateRangeNum = (rule, value, callback) => {
                value -= 0;
                const index = rule.field.slice(-1) - 0;
                if (value > this.countList[index]) {
                    callback();
                } else {
                    callback(new Error("必须大于前一个的次数"));
                }
            };
            const validateTitle = (rule, value, callback) => {
                const index = rule.field.slice(-1) - 0;
                if (
                    this.titleList.indexOf(value) !== -1 &&
                    this.titleList.indexOf(value) ===
                        this.titleList.lastIndexOf(value)
                ) {
                    callback();
                } else {
                    callback(new Error("标题名不要重复"));
                }
            };
            return {
                rangeNum0: [
                    { required: true, message: "等级范围必填" },
                    { validator: validateRangeNum, trigger: "blur" },
                ],
                rangeNum1: [
                    { required: true, message: "等级范围必填" },
                    { validator: validateRangeNum, trigger: "blur" },
                ],
                rangeNum2: [
                    { required: true, message: "等级范围必填" },
                    { validator: validateRangeNum, trigger: "blur" },
                ],

                title0: [
                    { required: true, message: "标题必填" },
                    { validator: validateTitle, trigger: "blur" },
                ],
                title1: [
                    { required: true, message: "标题必填" },
                    { validator: validateTitle, trigger: "blur" },
                ],
                title2: [
                    { required: true, message: "标题必填" },
                    { validator: validateTitle, trigger: "blur" },
                ],

                rate0: [{ required: true, message: "折扣比例必填" }],
                rate1: [{ required: true, message: "折扣比例必填" }],
                rate2: [{ required: true, message: "折扣比例必填" }],

                freezeDays0: [{ required: true, message: "冻结天数必填" }],
                freezeDays1: [{ required: true, message: "冻结天数必填" }],
                freezeDays2: [{ required: true, message: "冻结天数必填" }],
            };
        },

        countList() {
            const arr = [0];
            arr.push(this.info.rangeNum0 - 0);
            arr.push(this.info.rangeNum1 - 0);
            arr.push(this.info.rangeNum2 - 0);
            return arr;
        },
        titleList() {
            return [this.info.title0, this.info.title1, this.info.title2];
        },
    },

    methods: {
        fetch() {
            return sRewardRateList();
        },
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch()])
                .then((args) => {
                    var [view] = args;
                    if (view) {
                        var viewData = view.data;
                        // 实体数据
                        if (viewData.list.length) {
                            this.list = viewData.list;

                            this.list.forEach((item, index) => {
                                this.info["rate" + index] = item.rate * 100;
                                this.info["title" + index] = item.title;
                                this.info["rangeNum" + index] =
                                    item.rangeNum
                                        .slice(1, item.rangeNum.length - 1)
                                        .split(",")[1] / 10000;
                                this.info["freezeDays" + index] =
                                    item.freezeDays;
                            });
                        }
                    }
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.list.forEach((item, index) => {
                        item.rate = this.info["rate" + index] / 100;
                        item.title = this.info["title" + index];
                        item.rangeNum =
                            "[" +
                            this.countList[index] * 10000 +
                            "," +
                            this.countList[index + 1] * 10000 +
                            ")";
                        item.freezeDays = this.info["freezeDays" + index];
                    });
                    var formData = {};
                    formData.list = JSON.stringify(this.list);
                    return sRewardRateUpdate(formData);
                })
                .then((res) => {
                    this.$Message.success(this.$t("tips.update.success"));
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>
<style lang="less" scoped></style>
